export const EX_DISPLAY_SUBTYPE = 'Ex Display';
